export enum ChartTypeColorsEnum {
  singleColor = 1,
  colorsWeight = 2,
  allColors = 3,
}
